import React from 'react';
import './NewBenefit.scss';
import { ReactComponent as Triangle } from '../Assets/icons/benefit.svg';
import { ReactComponent as Books } from '../KodanshaButton/Assets/Books_Kodansha.svg';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { Link } from '../../Devon/Components/InkyLink';

const NewBenefit = () => {

    return (
        <>
            <div className='new-benefits-mobile-container'>
                <Books className='benefits-book-icon' />

                <div className='benefits-mobile-info-wrapper'>
                    <h2 className='benefits-book-header'>
                        Want to
                        read more
                        manga?
                    </h2>

                    <div className={'benefit-learn-more-mobile-wrapper'}>
                        <span>Open a free Reader account today and get more manga.</span>
                        <Link to={"/account-benefits/"}>
                            <KodanshaArrow text={'LEARN MORE'} invert />
                        </Link>
                        {/*<KodanshaArrow onClick={() => setLoginOverlay(true)} text={'Learn More'} invert*/}
                        {/*               withArrow={false} />*/}
                    </div>
                </div>

            </div>

            <div className='new-benefits-container'>
                <div className={'header-container'}>
                    <Books className='benefits-book-icon' />
                    <h2 className='benefits-book-header'>
                        <span>Want to</span>
                        <span>read more</span>
                        <span>manga?</span>
                    </h2>
                    <Triangle className={'benefit-triangle'} />
                </div>


                <div className='benefit-info-wrapper'>
                    <h2 className='benefits-info-header'>
                        Open a free Reader account and you'll get:
                    </h2>

                    <ul className='benefit-list'>
                        <li className='benefit-list-item'>Extra chapter previews on most Kodansha series.</li>
                        <li className='benefit-list-item'>Free volumes to read with our rotation of Spotlight Series.
                        </li>
                        <li className='benefit-list-item'>An online reader that always remembers your progress.</li>
                        <li className='benefit-list-item'>One place to read, buy, and collect our digital manga.</li>
                    </ul>
                </div>

                <Link className='benefit-learn-more-wrapper' to={"/account-benefits/"}>
                    <KodanshaUnderlinedText text={'Learn More'} />
                </Link>
                {/*{width > 1400 && }*/}
            </div>
        </>
    );
};

export default NewBenefit;